import EditGalleryContainer from "../containers/EditGalleryContainer";

const EditGalleryPage = () => {
  return (
    <EditGalleryContainer />
  );
};

export default EditGalleryPage;
